export default __webpack_public_path__ + "static/media/logo-primera-azul.43c2a2fd.png";